// 格式化费率，将小数转化成万分单位
export function formatRateToWan(val) {
  return parseFloat((val * 10000).toPrecision(12));
}

// 格式化费率，将小数转化成万分单位
export function formatRateForShow(val) {
  val = String(val).trim();
  val = isNaN(parseFloat(val)) ? 0 : parseFloat(val);
  return parseFloat(val * 10000).toFixed(2);
}

// 格式化费率，将整数改成小数
export function formatRateForSubmit(val) {
  val = String(val).trim();
  val = isNaN(parseFloat(val)) ? 0 : parseFloat(val);
  return parseFloat(val / 10000).toFixed(6);
}

// 将分格式成元，保留两位小数
export function formatMoneyToYuan(val) {
  val = String(val).trim();
  val = isNaN(parseFloat(val)) ? 0 : parseFloat(val);
  return parseFloat(val / 100).toFixed(2);
}

// 将元格式成分，不保留小数
export function formatMoneyToFen(val) {
  val = String(val).trim();
  val = isNaN(parseFloat(val)) ? 0 : parseFloat(val);
  return parseFloat(val * 100).toFixed(0);
}

// 格式化营业执照的日期
export function formatLicenseDate(val) {
  val = String(val).trim();
  return val.replace('年', '').replace('月', '').replace('日', '').replace('-', '');
}

// 控制费率录入格式
export function controlRateInput(val) {
  let result;
  // 取最后一位字符串
  const last = val.charAt(val.length - 1);
  // 自动将非法字符替换成空
  result = '1234567890.'.indexOf(last) < 0 ? val.replace(last, '') : val;
  // 自动将汉字符替换成空
  result = result.replace(/[\u4E00-\u9FA5]/g, '');
  return result;
}

// 控制金额录入格式
export function controlMoneyInput(val) {
  let result;
  // 取最后一位字符串
  const last = val.charAt(val.length - 1);
  // 自动将非法字符替换成空
  result = '1234567890.'.indexOf(last) < 0 ? val.replace(last, '') : val;
  // 自动将汉字符替换成空
  result = result.replace(/[\u4E00-\u9FA5]/g, '');
  return result;
}

// 控制电话录入格式
export function controlTelephoneInput(val) {
  let result;
  // 取最后一位字符串
  const last = val.charAt(val.length - 1);
  // 自动将非法字符替换成空
  result = '1234567890()（）-'.indexOf(last) < 0 ? val.replace(last, '') : val;
  // 自动将汉字符替换成空
  result = result.replace(/[\u4E00-\u9FA5]/g, '');
  return result;
}

// 控制身份证号录入格式
export function controlIdCardInput(val) {
  let result;
  // 取最后一位字符串
  const last = val.charAt(val.length - 1);
  // 自动将非法字符替换成空
  result = '1234567890X '.indexOf(last) < 0 ? val.replace(last, '') : val;
  // 自动将汉字符替换成空
  result = result.replace(/[\u4E00-\u9FA5]/g, '');
  // 第6位自动加空格，格式为：XXXXXX XXXXX
  if (result.length === 7 && last !== ' ') {
    const arr = result.split('');
    arr.splice(6, 0, ' ');
    result = arr.join('');
  }
  // 第15位自动加空格，格式为：XXXXXX XXXXXXXX XXX
  if (result.length === 16 && last !== ' ') {
    const arr = result.split('');
    arr.splice(15, 0, ' ');
    result = arr.join('');
  }
  return result;
}

// 控制手机号录入格式
export function controlMobileInput(val) {
  let result;
  // 取最后一位字符串
  const last = val.charAt(val.length - 1);
  // 自动将非法字符替换成空
  result = '1234567890 '.indexOf(last) < 0 ? val.replace(last, '') : val;
  // 自动将汉字符替换成空
  result = result.replace(/[\u4E00-\u9FA5]/g, '');
  // 第3位自动加空格，格式为：XXX XXXX
  if (result.length === 4 && last !== ' ') {
    const arr = result.split('');
    arr.splice(3, 0, ' ');
    result = arr.join('');
  }
  // 第8位自动加空格，格式为：XXX XXXX XXXX
  if (result.length === 9 && last !== ' ') {
    const arr = result.split('');
    arr.splice(8, 0, ' ');
    result = arr.join('');
  }
  return result;
}

// 控制银行卡号录入格式
export function controlBankCardInput(val) {
  let result;
  // 取最后一位字符串
  const last = val.charAt(val.length - 1);
  // 自动将非法字符替换成空
  result = '1234567890 '.indexOf(last) < 0 ? val.replace(last, '') : val;
  // 自动将汉字符替换成空
  result = result.replace(/[\u4E00-\u9FA5]/g, '');
  // 第4位自动加空格，格式为：XXXX XXXX
  if (result.length === 5 && last !== ' ') {
    const arr = result.split('');
    arr.splice(4, 0, ' ');
    result = arr.join('');
  }
  // 第9位自动加空格，格式为：XXXX XXXX XXXX
  if (result.length === 10 && last !== ' ') {
    const arr = result.split('');
    arr.splice(9, 0, ' ');
    result = arr.join('');
  }
  // 第14位自动加空格，格式为：XXXX XXXX XXXX XXXX
  if (result.length === 15 && last !== ' ') {
    const arr = result.split('');
    arr.splice(14, 0, ' ');
    result = arr.join('');
  }
  // 第19位自动加空格，格式为：XXXX XXXX XXXX XXXX XXX
  if (result.length === 20 && last !== ' ') {
    const arr = result.split('');
    arr.splice(19, 0, ' ');
    result = arr.join('');
  }
  return result;
}

// 控制营业执照号、登录密码录入格式
export function controlLicenseNoInput(val) {
  let result;
  // 取最后一位字符串
  const last = val.charAt(val.length - 1);
  // 自动将非法字符替换成空
  result = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(last) < 0 ? val.replace(last, '') : val;
  // 自动将汉字符替换成空
  result = result.replace(/[\u4E00-\u9FA5]/g, '');
  return result;
}

// 控制公司名称录入格式
export function controlCompanyNameInput(val) {
  // 取最后一位字符串
  const last = val.charAt(val.length - 1);
  // 自动将非法字符替换成空
  const result = last === ' ' ? val.replace(last, '') : val;
  return result;
}
